/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as FeedPostgate from '../feed/postgate.defs.js'
import * as FeedThreadgate from '../feed/threadgate.defs.js'
import * as LabelDefs from '../../../com/atproto/label/defs.defs.js'
import * as RepoStrongRef from '../../../com/atproto/repo/strongRef.defs.js'

const $nsid = 'app.bsky.draft.defs'

export { $nsid }

/** A draft with an identifier, used to store drafts in private storage (stash). */
type DraftWithId = {
  $type?: 'app.bsky.draft.defs#draftWithId'

  /**
   * A TID to be used as a draft identifier.
   */
  id: l.TidString
  draft: Draft
}

export type { DraftWithId }

/** A draft with an identifier, used to store drafts in private storage (stash). */
const draftWithId = l.typedObject<DraftWithId>(
  $nsid,
  'draftWithId',
  l.object({
    id: l.string({ format: 'tid' }),
    draft: l.ref<Draft>((() => draft) as any),
  }),
)

export { draftWithId }

/** A draft containing an array of draft posts. */
type Draft = {
  $type?: 'app.bsky.draft.defs#draft'

  /**
   * UUIDv4 identifier of the device that created this draft.
   */
  deviceId?: string

  /**
   * The device and/or platform on which the draft was created.
   */
  deviceName?: string

  /**
   * Array of draft posts that compose this draft.
   */
  posts: DraftPost[]

  /**
   * Indicates human language of posts primary text content.
   */
  langs?: l.LanguageString[]

  /**
   * Embedding rules for the postgates to be created when this draft is published.
   */
  postgateEmbeddingRules?: (
    | l.$Typed<FeedPostgate.DisableRule>
    | l.Unknown$TypedObject
  )[]

  /**
   * Allow-rules for the threadgate to be created when this draft is published.
   */
  threadgateAllow?: (
    | l.$Typed<FeedThreadgate.MentionRule>
    | l.$Typed<FeedThreadgate.FollowerRule>
    | l.$Typed<FeedThreadgate.FollowingRule>
    | l.$Typed<FeedThreadgate.ListRule>
    | l.Unknown$TypedObject
  )[]
}

export type { Draft }

/** A draft containing an array of draft posts. */
const draft = l.typedObject<Draft>(
  $nsid,
  'draft',
  l.object({
    deviceId: l.optional(l.string({ maxLength: 100 })),
    deviceName: l.optional(l.string({ maxLength: 100 })),
    posts: l.array(l.ref<DraftPost>((() => draftPost) as any), {
      minLength: 1,
      maxLength: 100,
    }),
    langs: l.optional(
      l.array(l.string({ format: 'language' }), { maxLength: 3 }),
    ),
    postgateEmbeddingRules: l.optional(
      l.array(
        l.typedUnion(
          [
            l.typedRef<FeedPostgate.DisableRule>(
              (() => FeedPostgate.disableRule) as any,
            ),
          ],
          false,
        ),
        { maxLength: 5 },
      ),
    ),
    threadgateAllow: l.optional(
      l.array(
        l.typedUnion(
          [
            l.typedRef<FeedThreadgate.MentionRule>(
              (() => FeedThreadgate.mentionRule) as any,
            ),
            l.typedRef<FeedThreadgate.FollowerRule>(
              (() => FeedThreadgate.followerRule) as any,
            ),
            l.typedRef<FeedThreadgate.FollowingRule>(
              (() => FeedThreadgate.followingRule) as any,
            ),
            l.typedRef<FeedThreadgate.ListRule>(
              (() => FeedThreadgate.listRule) as any,
            ),
          ],
          false,
        ),
        { maxLength: 5 },
      ),
    ),
  }),
)

export { draft }

/** One of the posts that compose a draft. */
type DraftPost = {
  $type?: 'app.bsky.draft.defs#draftPost'

  /**
   * The primary post content. It has a higher limit than post contents to allow storing a larger text that can later be refined into smaller posts.
   */
  text: string

  /**
   * Self-label values for this post. Effectively content warnings.
   */
  labels?: l.$Typed<LabelDefs.SelfLabels> | l.Unknown$TypedObject
  embedImages?: DraftEmbedImage[]
  embedVideos?: DraftEmbedVideo[]
  embedExternals?: DraftEmbedExternal[]
  embedRecords?: DraftEmbedRecord[]
}

export type { DraftPost }

/** One of the posts that compose a draft. */
const draftPost = l.typedObject<DraftPost>(
  $nsid,
  'draftPost',
  l.object({
    text: l.string({ maxLength: 10000, maxGraphemes: 1000 }),
    labels: l.optional(
      l.typedUnion(
        [l.typedRef<LabelDefs.SelfLabels>((() => LabelDefs.selfLabels) as any)],
        false,
      ),
    ),
    embedImages: l.optional(
      l.array(l.ref<DraftEmbedImage>((() => draftEmbedImage) as any), {
        maxLength: 4,
      }),
    ),
    embedVideos: l.optional(
      l.array(l.ref<DraftEmbedVideo>((() => draftEmbedVideo) as any), {
        maxLength: 1,
      }),
    ),
    embedExternals: l.optional(
      l.array(l.ref<DraftEmbedExternal>((() => draftEmbedExternal) as any), {
        maxLength: 1,
      }),
    ),
    embedRecords: l.optional(
      l.array(l.ref<DraftEmbedRecord>((() => draftEmbedRecord) as any), {
        maxLength: 1,
      }),
    ),
  }),
)

export { draftPost }

/** View to present drafts data to users. */
type DraftView = {
  $type?: 'app.bsky.draft.defs#draftView'

  /**
   * A TID to be used as a draft identifier.
   */
  id: l.TidString
  draft: Draft

  /**
   * The time the draft was created.
   */
  createdAt: l.DatetimeString

  /**
   * The time the draft was last updated.
   */
  updatedAt: l.DatetimeString
}

export type { DraftView }

/** View to present drafts data to users. */
const draftView = l.typedObject<DraftView>(
  $nsid,
  'draftView',
  l.object({
    id: l.string({ format: 'tid' }),
    draft: l.ref<Draft>((() => draft) as any),
    createdAt: l.string({ format: 'datetime' }),
    updatedAt: l.string({ format: 'datetime' }),
  }),
)

export { draftView }

type DraftEmbedLocalRef = {
  $type?: 'app.bsky.draft.defs#draftEmbedLocalRef'

  /**
   * Local, on-device ref to file to be embedded. Embeds are currently device-bound for drafts.
   */
  path: string
}

export type { DraftEmbedLocalRef }

const draftEmbedLocalRef = l.typedObject<DraftEmbedLocalRef>(
  $nsid,
  'draftEmbedLocalRef',
  l.object({ path: l.string({ minLength: 1, maxLength: 1024 }) }),
)

export { draftEmbedLocalRef }

type DraftEmbedCaption = {
  $type?: 'app.bsky.draft.defs#draftEmbedCaption'
  lang: l.LanguageString
  content: string
}

export type { DraftEmbedCaption }

const draftEmbedCaption = l.typedObject<DraftEmbedCaption>(
  $nsid,
  'draftEmbedCaption',
  l.object({
    lang: l.string({ format: 'language' }),
    content: l.string({ maxLength: 10000 }),
  }),
)

export { draftEmbedCaption }

type DraftEmbedImage = {
  $type?: 'app.bsky.draft.defs#draftEmbedImage'
  localRef: DraftEmbedLocalRef
  alt?: string
}

export type { DraftEmbedImage }

const draftEmbedImage = l.typedObject<DraftEmbedImage>(
  $nsid,
  'draftEmbedImage',
  l.object({
    localRef: l.ref<DraftEmbedLocalRef>((() => draftEmbedLocalRef) as any),
    alt: l.optional(l.string({ maxGraphemes: 2000 })),
  }),
)

export { draftEmbedImage }

type DraftEmbedVideo = {
  $type?: 'app.bsky.draft.defs#draftEmbedVideo'
  localRef: DraftEmbedLocalRef
  alt?: string
  captions?: DraftEmbedCaption[]
}

export type { DraftEmbedVideo }

const draftEmbedVideo = l.typedObject<DraftEmbedVideo>(
  $nsid,
  'draftEmbedVideo',
  l.object({
    localRef: l.ref<DraftEmbedLocalRef>((() => draftEmbedLocalRef) as any),
    alt: l.optional(l.string({ maxGraphemes: 2000 })),
    captions: l.optional(
      l.array(l.ref<DraftEmbedCaption>((() => draftEmbedCaption) as any), {
        maxLength: 20,
      }),
    ),
  }),
)

export { draftEmbedVideo }

type DraftEmbedExternal = {
  $type?: 'app.bsky.draft.defs#draftEmbedExternal'
  uri: l.UriString
}

export type { DraftEmbedExternal }

const draftEmbedExternal = l.typedObject<DraftEmbedExternal>(
  $nsid,
  'draftEmbedExternal',
  l.object({ uri: l.string({ format: 'uri' }) }),
)

export { draftEmbedExternal }

type DraftEmbedRecord = {
  $type?: 'app.bsky.draft.defs#draftEmbedRecord'
  record: RepoStrongRef.Main
}

export type { DraftEmbedRecord }

const draftEmbedRecord = l.typedObject<DraftEmbedRecord>(
  $nsid,
  'draftEmbedRecord',
  l.object({
    record: l.ref<RepoStrongRef.Main>((() => RepoStrongRef.main) as any),
  }),
)

export { draftEmbedRecord }
